module.exports = __webpack_public_path__ + "static/media/prenotazione_biglietti_voli.021279fa.png";